import type { SnapshotCheckIn } from './moodboardSnapshot';

export function addDays(date: number, days: number): number {
  const start = new Date(date);
  return new Date(start.getFullYear(), start.getMonth(), start.getDate() + days).getTime();
}

export function getWeekDays(weekStart: number): Date[] {
  return Array.from({ length: 7 }, (_, i) => new Date(addDays(weekStart, i)));
}

// Seven days from weekStart, each listing the student's check-ins newest first
export function getStudentWeek(checkIns: SnapshotCheckIn[], userId: string, weekStart: number): SnapshotCheckIn[][] {
  const mine = checkIns.filter((c) => c.userId === userId).sort((a, b) => b.createdAt - a.createdAt);
  return Array.from({ length: 7 }, (_, i) =>
    mine.filter((c) => c.createdAt >= addDays(weekStart, i) && c.createdAt < addDays(weekStart, i + 1)),
  );
}

export function getWeekNavigation(checkIns: SnapshotCheckIn[], weekStart: number, now: number) {
  return {
    hasPrevious: checkIns.some((c) => c.createdAt < weekStart),
    hasNext: addDays(weekStart, 7) <= now,
  };
}
